import React, { ChangeEvent, useContext, useEffect, useRef, useState } from "react";
import {
  ProgressCallback,
  SuccessCallback,
  uploadListPhoto,
  ErrorCallback,
  SKMediaType,
  uploadOGListImageByte,
  FolderName,
} from "../../../../../api/shared/uploadService";
import { UploadTask } from "firebase/storage";
import { CreateArtifactContext } from "../../../../../context/CreateArtifactContext";
import { ContentState } from "../../../../../models/SKArtifact";

interface LinkImageProvideWidgetProps {
  //onImageSelect: (file: File) => void;
  defaultImageUrl: string;
  photoBase64: string;
  index: number;
  title: string;
  information: string;
  documentId: string;
  onCoverImageUpload: (mediaUrl: string) => void;
  itemsSize: number;
  isClear: boolean;
}

export const LinkImageProvideWidget = ({
  //onImageSelect,
  defaultImageUrl,
  photoBase64,
  index,
  title,
  information,
  documentId,
  onCoverImageUpload,
  itemsSize,
  isClear,
}: LinkImageProvideWidgetProps) => {
  const { contentData, artifactId, updateContentData } = useContext(CreateArtifactContext);
  const [preview, setPreview] = useState<string | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [uploadingPhoto, setUploadingPhoto] = useState(false);
  const [imageTask, setImageTask] = useState<UploadTask | null>(null);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const tempImgRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    if (defaultImageUrl) {
      setPreview(defaultImageUrl);
    }
  }, [defaultImageUrl]);

  const progressCallback: ProgressCallback = (progress: number, mediaType: SKMediaType) => {
    console.log(`Upload progress: ${progress}%`);
  };

  useEffect(() => {
    if (isClear && preview) {
      setPreview("");
    }
  }, [isClear, preview]);

  const errorCallback: ErrorCallback = (error: Error, mediaType: SKMediaType) => {
    console.error(`Upload failed: ${error.message}`);

    setUploadingPhoto(false);
  };

  const successCallback: SuccessCallback = (url: string, mediaType: SKMediaType) => {
    onCoverImageUpload(url);
    setUploadingPhoto(false);
    console.log(`Upload successful! File URL: ${url}`);
  };

  useEffect(() => {
    const checkAndSetPreview = async () => {
      if (photoBase64.length) {
        setUploadingPhoto(true);
        try {
          let task = await uploadOGListImageByte(
            photoBase64,
            SKMediaType.photo,
            documentId,
            progressCallback,
            errorCallback,
            successCallback,
            FolderName.content
          );
          //setImageTask(task);
        } catch (error) {
          console.error("Error uploading image: ", error);
        } finally {
          setUploadingPhoto(false);
        }
      }
    };
    checkAndSetPreview();
  }, [photoBase64]);

  const handleChangeFile = (file: File, type: SKMediaType) => {
    if (file) {
      if (imageTask) {
        imageTask.cancel();
      }
      setUploadingPhoto(true);
      let task = uploadListPhoto(file, type, documentId, progressCallback, errorCallback, successCallback, FolderName.content);
      setImageTask(task);
    }
  };

  const handleClick = () => {
    if (contentData.status !== ContentState.DRAFT) {
      fileInputRef.current?.click();
    }
  };

  const removeImageClick = () => {
    //alert("You clicked me");
    setPreview(null);
    onCoverImageUpload("");
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // 🧹 Clear the old file from input!
    }
  };

  return (
    <div className="relative w-full min-w-[200px]">
      {title && (
        <div className="flex items-center">
          <span>{index && <span className="content_count">{index}</span>}</span>
          {title && <span className="content_title">{title}</span>}
        </div>
      )}
      {information && <div className="notes-class-content">{information}</div>}

      <div className="mb-4 mt-[15px]">
        <div
          className="flex relative items-center justify-center p-4 border-2 border-gray-300 border-separate w-[150px] h-[200px] max-w-[290px] max-h-[200px] rounded-md overflow-hidden"
          onClick={handleClick}
          style={{
            cursor: "pointer",
            border: "1px solid #ccc",
            padding: "0px",
            // display: "inline-block",
          }}
        >
          {preview && contentData.status !== ContentState.IN_REVIEW ? (
            <div className="absolute top-0 right-0 p-[4px] cursor-pointer">
              <button onClick={() => removeImageClick()} className="text-gray-500 hover:text-gray-700">
                <img src="/icons/CloseButton.png" alt="Close" className="w-5 h-5" />
              </button>
            </div>
          ) : (
            <></>
          )}
          <input
            type="file"
            ref={fileInputRef}
            accept={".jpg,.jpeg,.png,.heif,.gif"}
            onChange={e => handleChangeFile(e.target.files?.[0] as File, SKMediaType.photo)}
            className="hidden"
            id="file-upload"
          />

          {uploadingPhoto && (
            <div className="flex flex-col items-center justify-center space-y-4 bg-white border border-spacing-8 border-gray-50 rounded-2xl">
              <img src={"/icons/mediaupload.gif"} alt="Saving" className="w-[25px] h-[25px]" />
              <div className="font-bold text-center text-gray-400 w-[69px] h-[16px]">Uploading...</div>
              <button
                className="text-black border border-gray-400 rounded-md w-[53px] h-[30px]"
                onClick={e => {
                  e.stopPropagation();
                  // setImagePreview(null);
                  setUploadingPhoto(false);
                  imageTask && imageTask.cancel();
                }}
              >
                Cancel
              </button>
            </div>
          )}

          {/*           {uploadingPhoto && (
            <div className="flex items-center content-center w-full h-full">
              <p>Uploading...</p>
              <button onClick={() => {}}>Cancel Upload</button>
            </div>
          )} */}
          {!uploadingPhoto && preview && (
            <div className="w-full h-auto overflow-hidden">
              <img src={preview} alt="Profile" className="object-cover w-full h-auto" />
            </div>
          )}
          {!uploadingPhoto && !preview && (
            <label htmlFor="file-upload" className="flex items-center content-center h-full cursor-pointer">
              <div className="flex flex-col items-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 mb-2 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                </svg>
                <span className="w-2/3 text-xs text-center text-skgray">JPG, PNG, HEIF, or GIF</span>
              </div>
            </label>
          )}
        </div>
        {errorMessage && <p className="mt-2 text-sm text-red-500">{errorMessage}</p>}
      </div>
    </div>
  );
};
